// Updated View Component with Approve/Reject logic
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import noImage from "../../assets/images/no_image.jpg";
import moment from "moment";
import { AddCircle, Eye, Trash } from "iconsax-react";
import * as utils from "../../Utils/comman";
import Select from "react-select";
import PrimaryMenu from "../PrimaryMenu";
import { useSelector } from "react-redux";
import QueryModal from "./QueryModal";
import QueryList from "./QueryList";
import { Link, useLocation, useNavigate } from "react-router-dom";

function View(props) {
  const [itemList, setItemList] = useState([]);
  const [giftGroups, setGiftGroups] = useState([
    {
      description: "",
      items: [
        {
          itemId: "",
          qty: "",
          value: 0,
        },
      ],
    },
  ]);
  const [modalImage, setModalImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [deletedItemIds, setDeletedItemIds] = useState([]);
  const [isDisable, setIsDisable] = useState(true);
  const [status, setStatus] = useState("0");
  const [rejectReason, setRejectReason] = useState("");
  const [showRejectReason, setShowRejectReason] = useState(false);
  const [isBM, setIsBM] = useState(false);
  const [showQueryModal, setShowQueryModal] = useState(false);
  const [queryListRefreshTrigger, setQueryListRefreshTrigger] = useState(0);
  const [currentUserId, setCurrentUserId] = useState(
    props?.rowData?.request_by
  );
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  useEffect(() => {
    getItemList();
  }, []);

  const getItemList = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("id", "");
    bodyFormData.append("page", 1);
    bodyFormData.append("per_page", 100);
    bodyFormData.append(
      "is_bm",
      utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM")
        ? "yes"
        : "no"
    );

    utils
      .callAPI("post", `/sales/getmarketingList`, bodyFormData)
      .then((res) => {
        setItemList(res?.result || []);
      })
      .catch(() => setItemList([]));
  };

  const handleGroupChange = (groupIndex, field, value) => {
    const updatedGroups = [...giftGroups];
    updatedGroups[groupIndex][field] = value;
    setGiftGroups(updatedGroups);
  };

  const handleItemChange = (groupIndex, itemIndex, field, value) => {
    const updatedGroups = [...giftGroups];
    const selectedItem = itemList.find(
      (item) => item.id === updatedGroups[groupIndex].items[itemIndex].itemId
    );

    if (field === "itemId") {
      updatedGroups[groupIndex].items[itemIndex].itemId = value;
      updatedGroups[groupIndex].items[itemIndex].qty = "";
      updatedGroups[groupIndex].items[itemIndex].value = 0;
    } else if (field === "qty") {
      const price = selectedItem ? parseFloat(selectedItem.item_price) : 0;
      updatedGroups[groupIndex].items[itemIndex].qty = value;
      updatedGroups[groupIndex].items[itemIndex].value = value * price;
    }

    setGiftGroups(updatedGroups);
  };

  const addItemToGroup = (groupIndex) => {
    const updatedGroups = [...giftGroups];
    updatedGroups[groupIndex].items.push({ itemId: "", qty: "", value: 0 });
    setGiftGroups(updatedGroups);
  };

  const removeItemFromGroup = (groupIndex, itemIndex) => {
    const updatedGroups = [...giftGroups];
    const removedItem = updatedGroups[groupIndex].items[itemIndex];

    if (removedItem.dbId) {
      const selectedItem = itemList.find((i) => i.id === removedItem.itemId);
      setDeletedItemIds((prev) => [
        ...prev,
        {
          id: removedItem.dbId,
          marketing_material_id: removedItem.itemId,
          qty: removedItem.qty,
          price: selectedItem?.item_price || 0,
          total:
            parseFloat(selectedItem?.item_price || 0) *
            parseInt(removedItem.qty || 0),
        },
      ]);
    }

    updatedGroups[groupIndex].items.splice(itemIndex, 1);
    setGiftGroups(updatedGroups);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  const handleApprove = () => {
    setStatus("1");
    setRejectReason("");
    setIsSubmit(true);
  };

  const handleReject = () => {
    setShowRejectReason(true);
  };

  const handleRejectSubmit = () => {
    if (!rejectReason.trim()) {
      alert("Please enter a reason for rejection.");
      return;
    }
    setIsSubmit(true);
  };

  useEffect(() => {
    if (isSubmit) {
      const bodyFormData = new FormData();

      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props?.rowData?.id || "");
      }

      bodyFormData.append("description", giftGroups[0]?.description || "");

      const allItems = [];
      giftGroups.forEach((group) => {
        group.items.forEach((item) => {
          const selectedItem = itemList.find((itm) => itm.id === item.itemId);
          if (selectedItem) {
            allItems.push({
              id: item?.dbId || 0,
              marketing_material_id: item.itemId,
              qty: item.qty,
              price: selectedItem.item_price,
              total:
                parseFloat(selectedItem.item_price) * parseInt(item.qty || 0),
            });
          }
        });
      });

      bodyFormData.append("reject_reason", rejectReason);
      bodyFormData.append("emp_id", props?.rowData?.request_by);
      bodyFormData.append("req_items", JSON.stringify(allItems));
      bodyFormData.append("delete_req_items", JSON.stringify(deletedItemIds));

      const isBM = utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM");
      if (props?.rowData?.status == "2") {
        bodyFormData.append("status", 0);
        bodyFormData.append("updated_by", "emp");
      } else {
        bodyFormData.append("updated_by", isBM ? "bm" : "emp");
        bodyFormData.append("status", status);
      }

      utils
        .callAPI("post", "/meeting/popupgift/save", bodyFormData)
        .then((res) => {
          setIsSubmit(false);
          queryParams.delete("id");

          props.onChange({ mode: "list" });
        })
        .catch(() => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      const { description = "", req_items = [] } = props.rowData;
      const items = req_items.map((item) => ({
        itemId: item.marketing_material_id,
        qty: String(item.qty || ""),
        value: parseFloat(item.total || 0),
        dbId: item.id,
      }));

      setGiftGroups([{ description, items }]);
    }
  }, [props.rowData]);

  useEffect(() => {
    const isCreator =
      String(userProfile?.employeeId) === String(props?.rowData?.request_by);
    const hasBM = utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM");
    setIsBM(hasBM);
    if (isCreator || hasBM) {
      setIsDisable(false);
    }
  }, [primaryMenuRes, props?.rowData]);

  const handleBackClick = () => {
    queryParams.delete("id");

    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleQuery = () => {
    setShowQueryModal(true);
  };
  const refreshQueryList = () => {
    setQueryListRefreshTrigger((prev) => prev + 1);
  };
  const statusLabels = {
    0: { text: "Pending", variant: "Warning" },
    1: { text: "Approved", variant: "Success" },
    2: { text: "Rejected", variant: "Danger" },
  };

  return (
    <>
      <div className="section-body">
        <RB.Card className="shadow">
          <RB.Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              {String(userProfile?.employeeId) !==
              String(props?.rowData?.request_by)
                ? `${props?.rowData?.emp_first_name} ${props?.rowData?.emp_last_name} - `
                : ""}
              Popup Gift Details
              {statusLabels[props?.rowData?.status] && (
                <span
                  className={`ms-1 text-${statusLabels[
                    props.rowData.status
                  ].variant.toLowerCase()}`}
                  style={{ fontSize: "0.9rem" }}
                >
                  ({statusLabels[props.rowData.status].text})
                </span>
              )}
            </h5>

            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              Back
            </Link>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
              {giftGroups.map((group, groupIndex) => (
                <>
                  {group.items.map((item, itemIndex) => (
                    <RB.Row key={itemIndex} className="align-items-end mb-3">
                      <RB.Col md={4}>
                        <div className="d-flex align-items-end gap-2">
                          <div className="flex-grow-1 floating-label-fancy">
                            <Select
                              className="bom-productName-select"
                              classNamePrefix="react-select"
                              isDisabled={isDisable}
                              options={itemList.map((item) => ({
                                value: item.id,
                                label: item.item_name,
                              }))}
                              value={
                                item.itemId
                                  ? {
                                      value: item.itemId,
                                      label:
                                        itemList.find(
                                          (i) => i.id === item.itemId
                                        )?.item_name || "",
                                    }
                                  : null
                              }
                              onChange={(selectedOption) =>
                                handleItemChange(
                                  groupIndex,
                                  itemIndex,
                                  "itemId",
                                  selectedOption ? selectedOption.value : ""
                                )
                              }
                              placeholder="Select Item"
                              isClearable
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              menuPosition="fixed"
                            />
                          </div>

                          {item.itemId &&
                            (() => {
                              const selectedItem = itemList.find(
                                (i) => i.id === item.itemId
                              );
                              if (selectedItem?.item_image) {
                                return (
                                  <RB.Button
                                    size="sm"
                                    disabled={isDisable}
                                    className="btn-circle mt-1"
                                    onClick={() => {
                                      setModalImage(selectedItem.item_image);
                                      setShowModal(true);
                                    }}
                                    title="Preview Image"
                                  >
                                    <Eye size={16} />
                                  </RB.Button>
                                );
                              }
                              return null;
                            })()}
                        </div>
                      </RB.Col>

                      <RB.Col md={3}>
                        <RB.FloatingLabel
                          label="Qty"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            type="text"
                            placeholder="Qty"
                            value={item.qty}
                            readOnly={isDisable}
                            onChange={(e) => {
                              const inputValue = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              handleItemChange(
                                groupIndex,
                                itemIndex,
                                "qty",
                                inputValue
                              );
                            }}
                            required
                          />
                        </RB.FloatingLabel>
                      </RB.Col>

                      <RB.Col md={3}>
                        <RB.FloatingLabel
                          label="Value"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            type="text"
                            value={item.value}
                            // disabled
                            readOnly
                          />
                        </RB.FloatingLabel>
                      </RB.Col>

                      <RB.Col md={2} className="d-flex gap-2">
                        {/* Show only Remove if NOT the last item */}
                        {itemIndex !== group.items.length - 1 &&
                          group.items.length > 1 && (
                            <RB.Button
                              className="btn-circle"
                              variant="danger"
                              disabled={isDisable}
                              onClick={() =>
                                removeItemFromGroup(groupIndex, itemIndex)
                              }
                            >
                              <Trash />
                            </RB.Button>
                          )}

                        {/* Show only Add if this is the last item */}
                        {itemIndex === group.items.length - 1 && (
                          <>
                            {group.items.length > 1 && (
                              <RB.Button
                                className="btn-circle"
                                variant="danger"
                                disabled={isDisable}
                                onClick={() =>
                                  removeItemFromGroup(groupIndex, itemIndex)
                                }
                              >
                                <Trash />
                              </RB.Button>
                            )}
                            <RB.Button
                              className="btn-circle"
                              disabled={isDisable}
                              onClick={() => addItemToGroup(groupIndex)}
                            >
                              <AddCircle />
                            </RB.Button>
                          </>
                        )}
                      </RB.Col>
                    </RB.Row>
                  ))}

                  <RB.FloatingLabel label="Description" className="mt-3">
                    <RB.Form.Control
                      as="textarea"
                      rows={2}
                      value={group.description}
                      readOnly={isDisable}
                      onChange={(e) =>
                        handleGroupChange(
                          groupIndex,
                          "description",
                          e.target.value
                        )
                      }
                      placeholder="Enter description"
                    />
                  </RB.FloatingLabel>
                </>
              ))}
              {props?.rowData?.status == "2" && (
                <RB.FloatingLabel label="Reject Reason" className="mt-3">
                  <RB.Form.Control
                    as="textarea"
                    rows={2}
                    value={
                      props?.rowData?.reject_reason
                        ? props?.rowData?.reject_reason
                        : ""
                    }
                    readOnly
                    placeholder="Enter description"
                  />
                </RB.FloatingLabel>
              )}
              {props?.rowData?.status == "2" && (
                <RB.Row className="mt-3 align-items-center">
                  <RB.Col>
                    <RB.Button
                      variant="primary"
                      type="submit"
                      disabled={isDisable}
                    >
                      Submit
                    </RB.Button>
                  </RB.Col>
                </RB.Row>
              )}
              {props?.rowData?.status == "0" && (
                <RB.Row className="mt-3 align-items-center">
                  <RB.Col>
                    <RB.Button
                      variant="primary"
                      type="submit"
                      disabled={isDisable}
                    >
                      Submit
                    </RB.Button>
                  </RB.Col>

                  {isBM && (
                    <RB.Col className="text-end">
                      <RB.Button
                        variant="success"
                        className="me-2"
                        onClick={handleApprove}
                      >
                        Approve
                      </RB.Button>
                      <RB.Button variant="danger" onClick={handleReject}>
                        Reject
                      </RB.Button>
                    </RB.Col>
                  )}
                </RB.Row>
              )}
            </RB.Form>

            <RB.Card className="mt-2">
              <RB.CardBody>
                <RB.Row className="justify-content-end">
                  <RB.Col className="col-auto">
                    <RB.Button variant="warning" onClick={handleQuery}>
                      FeedBack
                    </RB.Button>
                  </RB.Col>
                </RB.Row>
                <QueryList
                  meetingId={props?.rowData?.id}
                  empId={currentUserId}
                  trigger={queryListRefreshTrigger}
                />
              </RB.CardBody>
            </RB.Card>
          </RB.Card.Body>
        </RB.Card>
        <QueryModal
          show={showQueryModal}
          onHide={() => setShowQueryModal(false)}
          meetingId={props?.rowData?.id}
          empId={currentUserId}
          onQuerySubmitted={refreshQueryList}
        />
      </div>
      <RB.Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setZoomLevel(1);
        }}
        centered
        size="lg"
      >
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>Image Preview</RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body className="text-center">
          {modalImage ? (
            <div
              onWheel={(e) => {
                e.preventDefault();
                setZoomLevel((prevZoom) => {
                  const delta = e.deltaY > 0 ? -0.1 : 0.1; // Scroll down = zoom out
                  const newZoom = prevZoom + delta;
                  return Math.min(3, Math.max(0.5, newZoom));
                });
              }}
              style={{
                overflow: "auto",
                cursor: "zoom-in",
              }}
            >
              <img
                src={modalImage}
                alt="Preview"
                style={{
                  transform: `scale(${zoomLevel})`,
                  transition: "transform 0.2s",
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                }}
              />
              <div className="text-muted mt-2" style={{ fontSize: "12px" }}>
                Scroll to zoom in/out
              </div>
            </div>
          ) : (
            <p>No image available</p>
          )}
        </RB.Modal.Body>
      </RB.Modal>

      <RB.Modal
        show={showRejectReason}
        onHide={() => setShowRejectReason(false)}
      >
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>Reject Request</RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body>
          <RB.FloatingLabel label="Enter reason for rejection">
            <RB.Form.Control
              as="textarea"
              rows={3}
              placeholder="Reason"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              required
            />
          </RB.FloatingLabel>
        </RB.Modal.Body>
        <RB.Modal.Footer>
          <RB.Button
            variant="secondary"
            onClick={() => setShowRejectReason(false)}
          >
            Cancel
          </RB.Button>
          <RB.Button
            variant="danger"
            onClick={() => {
              if (!rejectReason.trim()) {
                alert("Please enter a reason for rejection.");
                return;
              }
              setStatus("2");
              setIsSubmit(true);
              setShowRejectReason(false);
            }}
          >
            Submit Rejection
          </RB.Button>
        </RB.Modal.Footer>
      </RB.Modal>
    </>
  );
}

export default View;
